module.exports = __webpack_public_path__ + "static/media/icon-dashboard-registered-deal.1139198f.svg";